export default class GameRecommendations {
    constructor(api) {
        this.api = api;
        this.GameRecommendationsClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.gameRecommendationsInstance && this.api.settings.gameRecommendationsInstance !== instance.instance) {
            return;
        }

        if (!this.GameRecommendationsClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
                // await this.api.util.loadJS(["http://localhost:8081/widget_gameRecommendations.js"]);
                // await this.api.util.loadJS(["https://cdn.oryxgaming.com/widget/agg_widgets/2020-S13.1/ingame/gameRecommendations/js/gameRecommendations.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.gameRecommendations &&
                this.api.settings.widgetsUrl.gameRecommendations.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.gameRecommendations.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
                // await this.api.util.loadCSS(['https://cdn.oryxgaming.com/widget/agg_widgets/2020-S13.1/ingame/gameRecommendations/css/gameRecommendations.css']);
                // await this.api.util.loadCSS(['https://cdn.oryxgaming.com/widget/agg_widgets/2020-S13.1/ingame/gameRecommendations/css/gameRecommendations.css']);
                // await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/gameRecommendations/css/gameRecommendations.css']);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.gameRecommendations &&
                this.api.settings.widgetsUrl.gameRecommendations.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.gameRecommendations.css]);
            }
        }

        if (window.store) {
            window.store.dispatch('addInstanceToContainer', instance.instance)
            this.createInstance(instance)
        }
    }
    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.GameRecommendationsClass = new window.Widget_gameRecommendations.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}-inner`, instance.instance, this.api, instance.data && instance.data.settings ? instance.data.settings : {});
        }
    }
}
